import * as React from 'react';
import { useSelector } from 'react-redux';
import { Box, Stepper, Step, StepLabel, StepContent, Paper, Typography } from '@mui/material';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import MessagesPaneHeader from '../components/MessagesPaneHeader';
import { RootState } from '../store/AriStore';

const steps = [
  {
    label: '2025년 2월 18일',
    active: true,
    description: `* 25년 제4기 교육위원 운영안`,
  },
  {
    label: '2월 4일',
    active: true,
    description: `* 25년 선도위생모니터링 평가안\n* 우수 스토어매니저 양성안\n* OFC 이슈 발생 시 대응 요령 안내\n* GS ALL 런칭 및 GS ALL 포인트 출시 안내`,
  },
  {
    label: '1월 21일',
    active: true,
    description: `* 사용자 중심 POS 개선 보고\n* 점포 위생등급제 신규 제도\n* GS25 인스토어 리테일미디어 구축 방안`,
  },
  {
    label: '1월 14일',
    active: true,
    description: `* 음용수 위생관리 동의서 수취 안내`,
  },
  {
    label: '1월 7일',
    active: true,
    description: `* 우리동네GS 매장 구매 후기 오픈\n* 25년 재고조사 충당율 설정 안내\n* 재고감모 전입액 연말조정 제도 변경\n* 25년 신규 경영주 초기 안정 지원 제도 운영안\n* 25년 서비스 우수점 선정 기준 변경안\n* 25년 G-STEP 운영 변경안\n* 25년 판촉비 운영안\n* 25년 OFC 일하는 방식 개선 운영안`,
  },
  {
    label: '2024년 12월 24일',
    active: true,
    description: `* 편의점사업부 신점포유형 적용 안내\n* 편의점 고객 정의 안내\n* 에이아리 및 스토어맵 오픈 안내\n* 25년 영업MBO 임시운영\n* 25년 서비스MBO 평가안\n* FF외 폐기가능 상품 월별 재고감모 프로세스\n* 25년 상생지원 및 상생협약\n* 25년 인센티브 제도 운영안 및 열린 아카데미\n* 25년 시설업무 진행 방향성\n* 배민 부분취소 기능 도입\n* 25년 장보기 컨셉점 운영안`,
  }
];


export default function VerticalLinearStepper() {
  const menuInfo = useSelector((state: RootState) => state.menu);

  return (
    <>
      <Sidebar />
      <Header />
      <Box component="main" className="MainContent" sx={{ flex: 1 }}>
        <Paper
          key={menuInfo.selectedIndex}
          sx={{
            height: { xs: '100dvh', lg: '100dvh' },
            display: 'flex',
            flexDirection: 'column',
            pt: { xs: 'var(--Header-height)', sm: 0 },
          }}
        >
          <>
            <MessagesPaneHeader menuTitle={menuInfo.selectedName} />
            <Box sx={{ maxWidth: 400, pl: 3, pt: 3 }}>
              <Stepper activeStep={steps.length} orientation="vertical" >
                {steps.map((step, index) => (
                  <Step key={step.label} active={true}>
                    <StepLabel>
                      {step.label}
                    </StepLabel>
                    <StepContent>
                      <Typography style={{ whiteSpace: "pre-line" }}>{step.description}</Typography>
                    </StepContent>
                  </Step>
                ))}
              </Stepper>
            </Box>
          </>
        </Paper>
      </Box>
    </>
  );
}
